import PocketBase from 'pocketbase';

// Get PocketBase URL from environment variables with fallback
const pocketbaseUrl = import.meta.env.VITE_POCKETBASE_URL || 'https://roova.pockethost.io/';

// Ensure URL ends with trailing slash
const normalizedUrl = pocketbaseUrl.endsWith('/') ? pocketbaseUrl : `${pocketbaseUrl}/`;

// Initialize PocketBase with proper error handling
export const pb = new PocketBase(normalizedUrl);

// Configure PocketBase for better error handling
pb.beforeSend = function(url, options) {
  // Add custom headers if needed
  options.headers = {
    ...options.headers,
    'X-Requested-With': 'XMLHttpRequest',
  };
  
  return { url, options };
};

export const getCurrentUser = () => {
  return pb.authStore.model;
};

// Helper function to check if PocketBase is accessible
export const checkPocketBaseConnection = async () => {
  try {
    await pb.health.check();
    return { success: true, message: 'Connected to PocketBase' };
  } catch (error: unknown) {
    console.error('PocketBase connection error:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Unknown connection error'
    };
  }
};